import React, { Fragment } from 'react';
import { ResponsiveCheck } from 'core/providers/Responsive';
import PropTypes from 'prop-types';
import FormLogic from 'core/components/SignupWidget/FormLogic';
import Form from './Form';
import ThankYou from 'core/components/SignupWidget/ThankYou';
import Errored from 'core/components/SignupWidget/Errored';
import { FullContainer } from './styles';
import { SidebarSection, SidebarTitle } from 'discovery/styles';

const Container = ({ minimal, children, ...props }) => minimal ? (
	<SidebarSection {...props} noBorder>{children}</SidebarSection>
) : (
	<FullContainer {...props}>{children}</FullContainer>
);

const Markup = ({
	title,
	loading, success, errored,
	onObserve, submitHandler, errorOnClickBtn,
	submitText, thankYouTitle, thankYouMessage,
	minimal, message, alreadySubscribed, alreadySubscribedTitle, alreadySubscribedMessage,
}) => (
	<ResponsiveCheck>
		{({ isMobile }) => !isMobile && (
			<Container minimal={minimal}>
				{errored && !success && (
					<Errored errorOnClickBtn={errorOnClickBtn} />
				)}
				{success && !errored && (
					<ThankYou
						title={alreadySubscribed ? alreadySubscribedTitle : thankYouTitle}
						message={alreadySubscribed ? alreadySubscribedMessage : thankYouMessage}
						noCheck
					/>
				)}
				{!errored && !success && !alreadySubscribed && (
					<Fragment>
						{minimal ? (
							<SidebarTitle>{message}</SidebarTitle>
						) : (
							<h4>{title}</h4>
						)}
						{!minimal && <p>{message}</p>}
						<FormLogic submitHandler={submitHandler}>
							{({
								formHandler,
								inputChangeHandler,
								inputBlurHandler,
								inputFocusHandler,
								email,
								emailInvalid,
							}) => (
								<Form
									email={email}
									emailInvalid={emailInvalid}
									formHandler={formHandler}
									inputChangeHandler={inputChangeHandler}
									inputBlurHandler={inputBlurHandler}
									inputFocusHandler={inputFocusHandler}
									loading={loading}
									submitText={submitText}
								/>
							)}
						</FormLogic>
					</Fragment>
				)}
			</Container>
		)}
	</ResponsiveCheck>
);

Markup.propTypes = {
	loading: PropTypes.bool,
	success: PropTypes.bool,
	errored: PropTypes.bool,
	alreadySubscribed: PropTypes.bool,
	onObserve: PropTypes.func,
	submitHandler: PropTypes.func,
	errorOnClickBtn: PropTypes.func,
	submitText: PropTypes.string,
	thankYouTitle: PropTypes.string,
	thankYouMessage: PropTypes.string,
	alreadySubscribedTitle: PropTypes.string,
	alreadySubscribedMessage: PropTypes.string,
	minimal: PropTypes.bool,
	message: PropTypes.string,
	title: PropTypes.string,
};


Markup.defaultProps = {
	title: `Sign Up for Exclusive Deals`,
	message: `Call first dibs on limited-time offers, new boxes, and more.`,
	submitText: `Sign Me Up`,
	thankYouTitle: `Thanks`,
	thankYouMessage: `We'll send you and email to confirm your suscription`,
	alreadySubscribedTitle: `Good news!`,
	alreadySubscribedMessage: `You're already subscribed to our mailing list`,
};

export default Markup;
